import actions from "../../constants/actions";

export const changeLocale = locale => {
    return {
        type: actions.CHANGE_LOCALE,
        payload: {
            locale
        }
    };
};

export const changeRegion = region => {
    return {
        type: actions.CHANGE_REGION,
        payload: {
            region
        }
    };
};
